import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var IPhone = function IPhone(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97021 23.3452H16.0708C17.8242 23.3452 18.9932 22.1968 18.9932 20.4946V3.67822C18.9932 1.97607 17.8242 0.837891 16.0708 0.837891H7.97021C6.18604 0.837891 4.99658 1.97607 4.99658 3.67822V20.4946C4.99658 22.1968 6.18604 23.3452 7.97021 23.3452ZM8.31885 21.2329C7.50879 21.2329 7.04736 20.792 7.04736 20.0127V4.16016C7.04736 3.38086 7.50879 2.93994 8.31885 2.93994H8.73926V3.45264C8.73926 3.90381 9.03662 4.20117 9.47754 4.20117H14.5225C14.9634 4.20117 15.2607 3.90381 15.2607 3.45264V2.93994H15.6709C16.481 2.93994 16.9424 3.39111 16.9424 4.17041V20.0127C16.9424 20.792 16.481 21.2329 15.6709 21.2329H8.31885ZM9.26221 20.4229H14.7378C15.0352 20.4229 15.2607 20.2178 15.2607 19.8999C15.2607 19.5923 15.0352 19.3872 14.7378 19.3872H9.26221C8.96484 19.3872 8.73926 19.5923 8.73926 19.8999C8.73926 20.2178 8.96484 20.4229 9.26221 20.4229Z"
  })));
};

IPhone.displayName = 'IPhone';
export default IPhone;